
import NewHomeBannerList from '@/data/newHomeBanner/view/list.vue'
import newHomeBannerEditor from '@/data/newHomeBanner/view/editor.vue'

const list = {
  path: '/newHomeBanner',
  name: 'newHomeBanner-list',
  component: NewHomeBannerList
}
const creator = {
  path: '/newHomeBanner/creator',
  name: 'createNewHomeBanner',
  component: newHomeBannerEditor
}
const editor = {
  path: '/newHomeBanner/editor/:id(\\d+)',
  name: 'updateNewHomeBanner',
  component: newHomeBannerEditor
}

export default [list, creator, editor]
